import { TrucksHeaderContainer, TrucksHeaderHeadContainer, TrucksHeaderTopRow } from "./TrucksHeader.styles";
import { LinkButton } from "components/Common/Link";
import ProgressStepper from "components/Common/Stepper/Stepper";
import { CreateANewTruckText, StartOver, TruckOrdersText } from "constants/text";
import { Skeleton } from "@mui/material";
import { useDialog } from "hooks/useDialog.ts";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import SupportCTA from "components/Common/SupportCTA/SupportCTA";
import { getSupportFormUrl } from "utils/supportForm";

interface TrucksHeaderProps {
	isStepOne?: boolean;
	isLoading?: boolean;
}

const TrucksHeader = ({ isStepOne, isLoading }: TrucksHeaderProps) => {
	const { openDialog } = useDialog();
	const supportFormUrl = getSupportFormUrl({ type: "Order Help" });
	const handleDialogOpen = () => {
		openDialog({ dialogStatus: DialogTracking.LEAVE_TRUCK });
	};
	return (
		<TrucksHeaderContainer data-testid="create-truck-header">
			<TrucksHeaderTopRow>
				{isLoading ? (
					<Skeleton
						width={97}
						variant="rectangular"
					/>
				) : (
					<LinkButton
						hasBackIcon
						onClick={handleDialogOpen}
						data-testid="create-truck-start-over-link"
					>
						{isStepOne ? TruckOrdersText : StartOver}
					</LinkButton>
				)}
				{!isLoading && (
					<SupportCTA
						href={supportFormUrl}
						data-testid="trucks-support-button"
						sx={{ height: 30 }}
					/>
				)}
			</TrucksHeaderTopRow>
			<TrucksHeaderHeadContainer>
				<h4>{CreateANewTruckText}</h4>
				{isLoading ? <Skeleton variant="rectangular" /> : <ProgressStepper />}
			</TrucksHeaderHeadContainer>
			{isLoading && (
				<Skeleton
					height={151}
					variant="rectangular"
				/>
			)}
		</TrucksHeaderContainer>
	);
};

export default TrucksHeader;
